import {
    FETCH_AUSTRALIA_TOP_RANKED,
    FETCH_AUSTRALIA_TOP_RANKED_SUCCESS,
} from '../actions/australia-ranked-actions';

const initialState = {
    isLoading: false,
    error: null,
    players: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_AUSTRALIA_TOP_RANKED_SUCCESS:
            return {
                ...state,
                isLoading: false,
                players: action.payload.players,
            };

        case FETCH_AUSTRALIA_TOP_RANKED:
            return {
                ...state,
                isLoading: true,
            };

        default:
            return state;
    }
};
